
(function($) {
  var windowHeight = window.innerHeight;
  var windowWidth = window.innerWidth;

  if ($('body').hasClass('home') && windowWidth > 1080) {
    $(window).scroll(function() {
      if ($(this).scrollTop() > windowHeight -75){  
          $('.header').addClass("header--sticky");
          $('img.custom-logo').addClass('custom-logo--sticky');
      }
      else{
        $('.header').removeClass("header--sticky");
        $('img.custom-logo').removeClass('custom-logo--sticky');
      }
    });
  }  

  
}(jQuery));